import "./Affiliate.css";
import { Helmet } from "react-helmet";
import Card from "../components/Card/Card";
import Sidebar from "../components/Sidebar/Sidebar";
import Topbar from "../components/Topbar/Topbar";
import Refer from "../components/Refer/Refer";
import TopSelling from "../components/TopSelling/TopSelling";
import Charts from "../components/Charts/Charts";
import RecentSales from "../components/RecentSales/RecentSales";
import ReferModal from "../components/Modals/Refer/Refer";
import { useState } from "react";
import Share from "../components/Modals/Share/Share";
import RecentSalesModal from "../components/Modals/RecentSales/RecentSales";
import SidebarMobile from "../components/Sidebar/Mobile/SidebarMobile";

const Affiliate = () => {
 const [referModal, setReferModal] = useState(false);
 const [shareModal, setShareModal] = useState(false);
 const [recentSalesModal, setRecentSalesModal] = useState(false);

 return (
  <div className="affiliate-dashboard">
   <Helmet>
    <title> Home | Dashboard | SHAP</title>
    <meta
     name="description"
     content="Knowledge-based digital products distribution at a premium"
    />
   </Helmet>
   <div className="wrapper">
    <div className="side-bar">
     <Sidebar active="home" />
    </div>
    <div className="side-bar-mobile">
     <SidebarMobile active="home" />
    </div>

    <div className="content-container">
     <div className="modal-wrapper">
      <div
       className="referal"
       style={{ display: referModal ? "block" : "none" }}
      >
       <ReferModal
        setReferModal={setReferModal}
        setShareModal={setShareModal}
       />
      </div>

      <div
       className="referal"
       style={{ display: shareModal ? "block" : "none" }}
      >
       <Share setShareModal={setShareModal} setReferModal={setReferModal} />
      </div>

      <div
       className="recent-sales"
       style={{ display: recentSalesModal ? "block" : "none" }}
      >
       <RecentSalesModal setRecentSalesModal={setRecentSalesModal} />
      </div>
     </div>

     <Topbar heading="Home" />

     <div className="inner-content">
      <p style={{ color: "var(--primary-grey-text)" }}>Dashboard {">"} Home</p>
      <div className="card-wrapper">
       <Card />
      </div>

      <div className="refer-wrapper">
       <Refer setReferModal={setReferModal} />
      </div>

      <section className="charts-wrapper">
       <div className="chart-wrapper">
        <Charts />
       </div>
       <div className="top-selling-wrapper">
        <TopSelling />
       </div>
      </section>

      <div className="recent-sales-wrapper">
       <RecentSales setRecentSalesModal={setRecentSalesModal} />
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default Affiliate;
